import { Popover as CXPopOver, IPopover as CXIPopover } from '@sanlamcx/react-ui-next-popover';

export const Popover = CXPopOver;

export type IPopover = CXIPopover;
